import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';

/**
 * Fetches "What's New" (roadmap) pages from the gated advisors-api endpoint. refs
 * trade-platform/platform-operations#15873.
 *
 * The @auth0/angular-jwt interceptor attaches the user's bearer token automatically (apiDomain is
 * whitelisted in apps/advisor-ui/src/main.ts), so only a signed-in AIX user receives content — that
 * is the access control. Returns the raw HTML text (not JSON) for the modal to render in an iframe.
 */
@Injectable()
export class AixWhatsNewService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    getPage(path: string): Observable<string> {
        return this.http.get(`${this.environment.api}roadmap/${path}`, { responseType: 'text' });
    }
}
